export default {
    namespaced: true,
    state: () => ({
      gridCache : {}
    }),
    mutations: {
      setGridCache(state, data){
        state.gridCache[data.name] = data.filters;
      }
    },
    actions: {
      setGridCache({commit}, payload){
        commit("setGridCache", payload)
      }
    },
    getters: {
      getGridCache: (state) => (name) => {
        return state.gridCache[name];
      }
    }
  }